import { ScreenShell } from './AssistantScreens';
import { ActionRow } from '../../components/showroom/ActionChips';

// Property/condo secondary tier used to be 10+ compact tiles competing for the
// same glance. These groups are ONE entry tile each, leading here — the same
// consolidation the automotive showroom uses for Details & Specs.
//
// Rows, not a grid: a dedicated page whose only content is a short menu reads
// better stacked, and the icon chip sits at a fixed size so every row's glyph
// lands on the same x — the alignment bug the automotive tiles just had came
// from letting content height decide that.
export const ACCENT_HEX = {
    purple: '#A78BFA', cyan: '#22D3EE', green: '#34D399', blue: '#60A5FA',
    orange: '#FB923C', rose: '#FB7185', yellow: '#FBBF24', teal: '#2DD4BF',
    pink: '#F472B6', violet: '#8B5CF6', amber: '#FBBF24',
};

export const PropertyGroupScreen = ({ group, tx, onBack }) => (
    <>
        <ScreenShell title={group.title} onBack={onBack} tx={tx} testId={`assistant-group-${group.id}`}>
            <div className="space-y-2.5">
                {group.rows.map((r) => (
                    <ActionRow key={r.key} color={ACCENT_HEX[r.accent] || ACCENT_HEX.teal}
                        icon={r.icon} label={r.label} sublabel={r.tag}
                        onClick={r.onClick} testid={`assistant-group-row-${r.key}`} />
                ))}
            </div>
        </ScreenShell>
        {/* The assistant shell vertically CENTRES short pages, which left a short
            menu floating in the middle of the screen. This spacer takes the
            leftover height so the rows start at the top instead. */}
        <div aria-hidden="true" className="flex-1" />
    </>
);

export default PropertyGroupScreen;
